//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { VueEditor } from 'vue2-editor'
import { mapActions } from 'vuex'

export default {
  name: 'CategoryInstructionsModal',
  components: {
    VueEditor
  },
  props: {
    owner: {
      type: String,
      required: true
    },
    ownerType: {
      type: Number,
      required: true
    },
    primaryCategory: {
      type: String,
      default: ''
    },
    secondaryCategory: {
      type: String,
      default: ''
    },
    existingInstructions: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      instructionsContent: '',
      saving: false,
      toolbar: [
        [{ header: [false, 1, 2, 3] }],
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link'],
        ['clean']
      ]
    }
  },
  methods: {
    ...mapActions({
      saveCategoryInstruction: 'questions/saveCategoryInstruction'
    }),
    onShow() {
      this.instructionsContent = this.existingInstructions || ''
    },
    onHidden() {
      this.instructionsContent = ''
      this.saving = false
    },
    async save() {
      this.saving = true
      try {
        await this.saveCategoryInstruction({
          owner: this.owner,
          type: this.ownerType,
          primaryCategory: this.primaryCategory,
          secondaryCategory: this.secondaryCategory,
          instructions: this.instructionsContent
        })
        this.$emit('saved', this.instructionsContent)
        this.$bvModal.hide('modal-category-instructions')
      } finally {
        this.saving = false
      }
    }
  }
}
